import React, { useState, useEffect, useCallback } from 'react'
import { useTranslation } from "react-i18next";
import styles from './ModuleBuilder.module.css'
import { Tabs, Tab } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";

const ModuleBuilder = (props) => {
    const [activeTab, setActiveTab] = useState('all')
    const [t] = useTranslation('crm')
    const navigate = useNavigate();

    const { crmState, manageCrmModuleSelectedObj } = props
    const { name: moduleName, value: settingType } = crmState.crmPath
    const onNewTabSelectedHandler = useCallback((newTab) => {
        // setActiveTab(newTab)
        navigate(`/crm/${moduleName}/settings/${newTab}`)
    }, [moduleName])

    useEffect(() => {
        setActiveTab(settingType)
    }, [settingType])

    return (
        <Tabs id='module-builder-tabs' className={`cusTabs-contactlist open-contact-modal-tabs `} defaultActiveKey='all' activeKey={activeTab} onSelect={onNewTabSelectedHandler}>

            <Tab className={`${styles['modal-tab']}`} tabClassName={`${styles['details-tab']}`} eventKey='fields-managment' title={`${t('Fields managment')}`}>

            </Tab>
            <Tab className={`${styles['modal-tab']}`} tabClassName={`${styles['details-tab']}`} eventKey='module-layout' title={`${t('Module layout')}`}>

            </Tab>
            <Tab className={`${styles['modal-tab']}`} tabClassName={`${styles['details-tab']}`} eventKey='grid-columns' title={`${t('Grid columns')}`}>

            </Tab>
            <Tab className={`${styles['modal-tab']}`} tabClassName={`${styles['details-tab']}`} eventKey='grid-filters' title={`${t('Grid filters')}`}>

            </Tab>
            <Tab className={`${styles['modal-tab']}`} tabClassName='details-tab tab-border' eventKey='relationships' title={`${t('Module Relationships')}`}>

            </Tab>
        </Tabs>
    )
}
export default ModuleBuilder